import { fetchWithAuth } from '../utils/fetchWithAuth';
import { unwrapResponse as unwrap } from '../utils/unwrapResponse';

const BASE = 'admin/technicians/geocoding';

export interface AddressSuggestion {
  placeId: string;
  label: string;
}

/** `unavailable` = no Places key (L2c-g); `failed` = the provider refused or timed out. */
export interface AddressSuggestions {
  status: 'ok' | 'unavailable' | 'failed';
  suggestions: AddressSuggestion[];
}

export interface PlaceAddress {
  line1: string | null;
  postalCode: string | null;
  city: string | null;
  latitude: number;
  longitude: number;
}

export const fetchAddressSuggestions = async (q: string, country: string | null): Promise<AddressSuggestions> => {
  const params = new URLSearchParams({ q });
  if (country) params.set('country', country);
  return unwrap<AddressSuggestions>(await fetchWithAuth(`${BASE}/autocomplete?${params}`), 'Failed to suggest addresses');
};

export const fetchPlaceAddress = async (placeId: string): Promise<PlaceAddress | null> =>
  (
    await unwrap<{ address: PlaceAddress | null }>(
      await fetchWithAuth(`${BASE}/places/${encodeURIComponent(placeId)}`),
      'Failed to resolve the place'
    )
  )?.address ?? null;
